// src/constants/paymentMethods.js
export const CASH_PAYMENT_METHOD = { key: "cash", label: "Cash", type: "cash" };
export const HITPAY_AUTO_CHECKOUT_METHOD = "hitpay_checkout";

export const HITPAY_EWALLET_METHODS = [
    { key: "gcash", label: "GCash", type: "hitpay", group: "wallet", sandboxSupported: false },
    { key: "grabpay", label: "GrabPay", type: "hitpay", group: "wallet", sandboxSupported: true },
    { key: "shopeepay", label: "ShopeePay", type: "hitpay", group: "wallet", sandboxSupported: true },
    { key: "qrph", label: "QR Ph", type: "hitpay", group: "bank_card", sandboxSupported: false },
    { key: "card", label: "Card", type: "hitpay", group: "bank_card", sandboxSupported: true },
];

export const PAYMENT_METHODS = [
    CASH_PAYMENT_METHOD,
    HITPAY_EWALLET_METHODS[0],
];

// Derived map for easy lookup
export const PAYMENT_LABELS = Object.fromEntries(
    [CASH_PAYMENT_METHOD, ...HITPAY_EWALLET_METHODS].map(method => [method.key, method.label])
);

export const isHitpayEwalletMethod = (method) =>
    method === HITPAY_AUTO_CHECKOUT_METHOD
    || HITPAY_EWALLET_METHODS.some((option) => option.key === String(method || "").toLowerCase());

export const getPaymentMethodLabel = (method) =>
    PAYMENT_LABELS[String(method || "").toLowerCase()] || method || "E-Wallet";

export const getPaymentMethodsForCheckout = (enabledEwalletMethods = [HITPAY_AUTO_CHECKOUT_METHOD]) => {
    const allowed = new Set((Array.isArray(enabledEwalletMethods) ? enabledEwalletMethods : [])
        .map((method) => String(method?.key || method || "").toLowerCase()));
    return [
        CASH_PAYMENT_METHOD,
        ...HITPAY_EWALLET_METHODS.filter((method) => allowed.has(method.key)),
    ];
};

export const getPaymentMethodsByGroup = (methods = [], group) => {
    const allowed = new Set((Array.isArray(methods) ? methods : [])
        .map((method) => String(method?.key || method || "").toLowerCase()));
    return HITPAY_EWALLET_METHODS.filter((method) => method.group === group && allowed.has(method.key));
};
